import styled, { css } from 'styled-components';
import { FlexColumn, FlexibleDiv } from '../../../../styled/common';
import { Typography } from '../../../ui/Typography';

export const ScheduleAndLocationBlockContainer = styled(FlexColumn)`
  gap: 10px;
  margin-bottom: 15px;
`;

export const BlockRow = styled(FlexibleDiv)`
  gap: 10px;
  align-items: center;
`;

export const ScheduleText = styled(Typography)`
  flex: 1;
`;

export const LocationText = styled(Typography)<{ $isCoordinates: boolean }>`
  color: ${({ theme: { colors } }) => colors.text.primary};
  flex: 1;
  transition: all 0.2s ease-in-out;

  ${({ $isCoordinates }) =>
    $isCoordinates &&
    css`
      text-decoration: underline;
      cursor: pointer;
    `};

  @media (hover: hover) {
    &:hover {
      color: ${({ theme }) => theme.colors.systemColors.blue};
    }
  }
`;
